import { User } from '../../models/user'

export class TokenValidationResult {
  tokenIsValid: boolean
  loginContext: User
}
